import React from "react";
import classNames from "classnames";

interface CustomColorThemeProps {
    children?: React.ReactNode;
    additionalClassNames?: string[];
}

/**
 * Set `custom-color-theme` to `div` element for custom branding - font theme in addition to additional class names.
 */
export const CustomColorThemeDiv = (props: CustomColorThemeProps) => {
    return (
        <div
            className={classNames(
                "custom-color-theme",
                ...(props.additionalClassNames ?? [])
            )}
        >
            {props.children}
        </div>
    );
};

/**
 * Set `custom-color-theme` to `span` element for custom branding - font theme in addition to additional class names.
 */
export const CustomColorThemeSpan = (props: CustomColorThemeProps) => {
    return (
        <span
            className={classNames(
                "custom-color-theme",
                ...(props.additionalClassNames ?? [])
            )}
        >
            {props.children}
        </span>
    );
};
